import axios from 'axios';
import { Toast, Dialog, Notify } from 'vant';
import store from '../store/index';
import router from '../router/index';
import { encryption,encrypt,decrypt } from './public'

function startLoading(text = '加载中...') {
  Toast.loading({
    duration: 0, // 持续展示 toast
    message: text,
    forbidClick: true,
  });
}

function endLoading() {
  Toast.clear();
}

//声明一个对象用于存储请求个数
let needLoadingRequestCount = 0;

function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
}

function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
}

// 请求超时时间
// axios.defaults.timeout = 10000;

// 请求来源区分
axios.defaults.headers.common["code-source"] = 'h5-source';

// post请求头
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

// 请求拦截器
axios.interceptors.request.use((config) => {
  if(config.data) {
    if (JSON.stringify(config.data) == '{}') {
      config.data = undefined
    } else if(JSON.stringify(config.data) !== '{}') {
      config.data = encrypt(JSON.stringify(config.data))
    }
  }
  if(config.params) {
    if(JSON.stringify(config.params) !== '{}') {
      for(let key in config.params){
        config.params[key] = encrypt(config.params[key]?config.params[key] : '')
      }
    } else if(JSON.stringify(config.params) == '{}') {
      config.params = undefined
    }
  }
  showFullScreenLoading()
  const openid = store.state.userInfo.openid || localStorage.getItem('Openid');
  const snowflakeId = store.state.userInfo.SnowflakeId || localStorage.getItem('SnowflakeId');
  const mobile = localStorage.getItem('mobile');
  const Authorization = store.state.userInfo.Authorization || localStorage.getItem('Authorization');
  Authorization && (config.headers["Authorization"] = Authorization);
  openid && (config.headers["openid"] = openid);
  snowflakeId && (config.headers["uid"] = snowflakeId);
  mobile && (config.headers["mobile"] = mobile);
  return config;
}, (err) => {
  Toast({
    message: '请求超时!',
    duration: 1000,
    forbidClick: true
  });
  tryHideFullScreenLoading()
  return Promise.reject(err);
});
let show = false
// 响应拦截器
axios.interceptors.response.use((response) => {
  if(!show) {
    if(response.data.data && Object.prototype.toString.call(response.data.data ) === '[object String]'){
      let data = decrypt(response.data.data)
      try {
        response.data.data = typeof JSON.parse(data) == 'object'? JSON.parse(data) : data
      } catch (error) {
        response.data.data = data
      }
    }
    if (response.status === 200) {
      // setTimeout(function () {
        tryHideFullScreenLoading()
      // }, 300)
      return Promise.resolve(response);
    } else {
      // setTimeout(fu401nction () {
        tryHideFullScreenLoading()
      // }, 300)
      return Promise.reject(response);
    }
  }
}, (error) => {
  if(!show) {
    tryHideFullScreenLoading()
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录                 
        case 401:
          store.dispatch('hasInfo').then(res => { })
          break;
          // 403 token过期          
        case 403:
          Toast({
            message: '登录过期，请重新登录',
            duration: 1000,
            forbidClick: true
          });
          // 清除token  
          localStorage.clear() //清楚所有数据
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          // setTimeout(() => {
          //   router.replace({
          //     path: getUrl(),
          //   });
          // }, 1000);
          break;
          // 404请求不存在                
        case 404:
          Toast({
            message: '网络请求不存在',
            duration: 1500,
            forbidClick: true
          });
          break;
          // 其他错误，直接抛出错误提示                
        default:
          if(error.response.data.error == 'Service Unavailable' || error.response.data.error == 'Internal Server Error'){ // 服务不在线
            show = true
            Toast({
              duration: 0, // 持续展示 toast
              forbidClick: true,
              className:'unavailable',
            });
          }else{
            Toast({
              message: error.response.data.message,
              duration: 1500,
              forbidClick: true
            });
          }
      }
      return Promise.reject(error.response);
    }
  }
})
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
        params: params
      })
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        if(err.status == 401) {
          return false
        }
        reject(err)
      })
  })
}
/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        if(err.status == 401) {
          return false
        }
        reject(err)
      })
  })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data)
      .then(response => {
        resolve(response);
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data)
      .then(response => {
        resolve(response);
      }, err => {
        reject(err)
      })
  })
}
/**
   * 定义一个ajax的请求函数
   * @param {String} url
   * @param {String} methods
   * @param {String} field
   * @param {Object} params
   */
export function ajax({url,methods = "post",field,params = {}, notice = true}) {
  let show = false
  methods = methods.toLowerCase()
  if(!field) {
    field = methods === 'get'? 'params' : 'data'
  }
  // 创建一个Promise对象方便抛出请求结果
  return new Promise(((resolve,reject)=>{
    axios({
      url,
      method:methods,
      [field]:params
    })
    .then((response) => {
      if(!response) {
        show = true
        Toast({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          className:'unavailable',
        });
        return false
      }
      if(!show) {
        if(response.status === 200) {
          let {data} = response
          if (data.success) {
            // 请求成功抛出请求结果
            resolve(data.data)
          } else {
            // 请求失败打印失败原因
            reject(response.data)
            if(notice) {
              Toast.fail(data.message)
            }
          }
        } else {
          reject(response);
          if(notice) {
            Toast.fail(response.message)
          }
        }
      }
    })
    .catch((err) => {
      if(err.status == 401) {
        return false
      }
      reject(err);
      if(err.data.error == 'Service Unavailable' || err.data.error == 'Internal Server Error'){ // 服务不在线
        show = true
        Toast({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          className:'unavailable',
        });
      } else if(notice) {
        if(!show) {
          Toast.fail(err.statusText)
        }
      }
    })
  }))
}
export function requestDetailById(url,methods = 'get') {
  return ajax({url,methods})
}



// WEBPACK FOOTER //
// ./src/utils/request.js